
export const NotFoundPage = () => {
    return <div className="page-section">
        <h1 className="page-title">Страница не найдена</h1>
    </div>
}